/*import './capabilities.component.js';*/
import './clients.component.js';